import React from 'react';
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import LoaderHome from "../../../../Loader/LoaderHome";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { sortDimensiByTingkatan } from "./component/sortDimensiByTingkatan";
import { ClipLoader, PulseLoader} from "react-spinners";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }
  `;


/* =============================================================================================== */
/* ===============================  MAIN COMPONENT  =============================================== */
/* =============================================================================================== */

export default function PengaturanDimensiHead() {
  document.title = "Pengaturan Dimensi";

   const [savingMap, setSavingMap] = useState({});

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);

  // Table data
  const [getData, setGetData] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);
  const queryKeyRef = useRef(""); // ✅ guard supaya response toggle/fetch tidak nyasar ke filter lain

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
      const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  // ✅ filterKey utk membuat state toggle tidak bentrok antar filter
  const filterKey = useMemo(() => {
    return [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_dimensi_id,
    ].join("|");
  }, [form2.ysb_semester_id, form2.ysb_branch_id, form2.ysb_school_id, form2.ysb_dimensi_id]);

  // =========================
  // INIT: Branch + Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes, dimensiRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Branch default pertama
      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

      // Dimensi aktif pertama
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
        if (dims.length > 0) setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0].id }));
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    }
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      setLoadingSchool(true); // ⬅️ school mulai load
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );
        if (res?.status === 200) {
          let schools = res.data.data || [];

          // ✅ FILTER ULANG UNTUK ROLE DEVELOPER
          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter((s) => s.ysb_branch_id === branchId);
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          // default sekolah pertama
          if (schools.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
            }));
          } else {
            setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_teacher_id: "" }));
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingSchool(false); // ⬅️ school SELESAI
        setLoading(false); // ⬅️ shimmer BARU MATI DI SINI
      }
    },
    [ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  // =========================
  // Filter complete (Guru gak wajib)
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_dimensi_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !form2.ysb_dimensi_id) return;

    const params = {
      ysb_semester_id: form2.ysb_semester_id,
      level: storageLevel,
      branch: form2.ysb_branch_id,
      ysb_dimensi_id: form2.ysb_dimensi_id,
      ysb_school_id: form2.ysb_school_id,
    };

    const qk = JSON.stringify(params);
    queryKeyRef.current = qk;

    try {
      const response = await APILA.get("/api/dimensi-config-heads/head", { params, ...fetchParams });

      // ✅ kalau user sudah pindah filter, jangan timpa state filter terbaru
      if (queryKeyRef.current !== qk) return;

      if (response?.status === 200) {
        const sorted = sortDimensiByTingkatan([...(response.data.data || [])]);
        setGetData(sorted);

        // ✅ penting: reset state lokal supaya selalu sesuai server
        setSavingMap({});
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data",
        icon: "error",
      });
    }
  }, [form2.ysb_semester_id, form2.ysb_branch_id, form2.ysb_school_id, form2.ysb_dimensi_id, fetchParams, storageLevel]);

  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD: tampilkan table otomatis setelah default filter lengkap
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_dimensi_id
    )
      return;

    firstLoadDone.current = true;

    (async () => {
      setIsFetching(true);
      await GetResponseData(); // ✅ HANYA SEKALI
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  }, [form2.ysb_semester_id, form2.ysb_branch_id, form2.ysb_school_id, form2.ysb_dimensi_id, GetResponseData]);

  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [form2.ysb_semester_id, form2.ysb_branch_id, form2.ysb_school_id, form2.ysb_dimensi_id, form2.ysb_teacher_id]);

  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
      // ✅ jangan simpan value toggle dari filter lama
      setSavingMap({});
    }
  };

  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !form2.ysb_dimensi_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester, Cabang, Sekolah, dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  /* =============================================================================================== */
  /* ===============================  TOGGLE FUNCTION ============================================= */
  /* =============================================================================================== */

  const id_user = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "");

  const extractReturnedId = (res) => {
    // ✅ fleksibel: tergantung bentuk response backend
    return (
      res?.data?.data?.ysb_dimensi_config_head_id ||
      res?.data?.data?.id ||
      res?.data?.ysb_dimensi_config_head_id ||
      res?.data?.id ||
      null
    );
  };

  const handleToggleSubElement = async (sub, rekapan, element, newState, cellId, qk) => {
    const isDefault = sub.ysb_dimensi_config_head_id === "default";

    const endpoint = isDefault
      ? `/api/dimensi-config-heads/default`
      : `/api/dimensi-config-heads/${sub.ysb_dimensi_config_head_id}`;

    const payload = {
      ysb_branch_id: form2.ysb_branch_id,
      ysb_school_id: form2.ysb_school_id,
      ysb_semester_id: form2.ysb_semester_id,
      ysb_grade_level_id: rekapan.ysb_grade_level_id,
      ysb_element_id: element.id,
      ysb_sub_element_id: sub.ysb_sub_element_id,
      state_form: newState,
      user_id: id_user,
    };

    try {
      setSavingMap((prev) => ({ ...prev, [cellId]: true }));

      const res = await APILA.put(endpoint, payload, fetchParams);

      // ✅ kalau user sudah pindah filter, jangan update UI filter baru
      if (queryKeyRef.current !== qk) {
        ToastSuccess.fire({ icon: "success", title: res?.data?.message || "Berhasil disimpan" });
        return;
      }

      if (res.status === 200) {
        const returnedId = extractReturnedId(res);

        setGetData((prev) =>
          prev.map((dim) => ({
            ...dim,
            data_element: dim.data_element.map((el) => ({
              ...el,
              rekapan: el.rekapan.map((r) => ({
                ...r,
                sub_elements: r.sub_elements.map((s) => {
                  const match =
                    s.ysb_sub_element_id === sub.ysb_sub_element_id &&
                    r.ysb_grade_level_id === rekapan.ysb_grade_level_id &&
                    el.id === element.id;

                  if (!match) return s;

                  return {
                    ...s,
                    form_state: newState,
                    // ✅ PENTING: kalau awalnya default dan backend kasih id baru, simpan id baru itu
                    ysb_dimensi_config_head_id: returnedId ? returnedId : s.ysb_dimensi_config_head_id,
                  };
                }),
              })),
            })),
          }))
        );

        ToastSuccess.fire({
          icon: "success",
          title: res.data.message,
        });
      }
    } catch (err) {
      ToastError.fire({
        icon: "error",
        title: err?.response?.data?.message || err.message,
      });

      // ✅ kalau error, refresh data dari server supaya balik sesuai DB
      try {
        if (queryKeyRef.current === qk) {
          await GetResponseData();
        }
      } catch (_) {}
    } finally {
      setSavingMap((prev) => {
        const clone = { ...prev };
        delete clone[cellId];
        return clone;
      });
    }
  };

  /* =============================================================================================== */
  /* ===============================  RENDER PAGE ================================================== */
  /* =============================================================================================== */

  return (
    <>
    <style>{shimmerStyle}</style>

    <div className="body">
      {/* <div className="body-header d-flex">
        <div className="title-page">
          {isTabletOrMobile ? (
            <h6>
              <FontAwesomeIcon icon={faGear} /> Konfigurasi Nilai
            </h6>
          ) : (
            <h5>
              <FontAwesomeIcon icon={faGear} /> Konfigurasi Nilai
            </h5>
          )}
        </div>
      </div> */}

      <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGear} />
                  </span>
                <h4 className="page-title-text"> Konfigurasi Nilai</h4>
              </div>
            </div>

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                 <li className="custom-breadcrumb-item">
                  <Link to="/element-recaps-dimensi">Penilaian</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Konfigurasi Nilai
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGear} />
                </span>
                <h4 className="page-title-text"> Konfigurasi Nilai</h4>
              </div>

              
            </div>



            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li className="custom-breadcrumb-item">
                  <Link to="/element-recaps-dimensi">Penilaian</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Konfigurasi Nilai
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>

      {/* BREADCRUMB */}
      {/* <div className="body-content-menu">
        <div className="breadcrumb-header " style={{fontSize:"13px" }}>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"> <Link style={{textDecoration:"none"}} to="">Beranda</Link>  </li>
              <li className="breadcrumb-item" > <Link style={{textDecoration:"none"}} to="/element-recaps-dimensi"> <span className='ml-2'> Penilaian </span> </Link> </li>
              <li className="breadcrumb-item iniaktif" > <span className='ml-2'> Konfigurasi Nilai </span> </li>
            </ol>
          </nav>
        </div>
      </div> */}

      {/* PAGE CONTENT */}
      <div className="body-content">

        {/* ========================== TAB MENU ========================== */}

        <div className='d-flex mb-4'>
          <div>
            <button  className=" btn " style={{fontSize: '15px', padding:'5px 10px', marginTop: '-2px',  borderRadius: "10px 10px 0px 0px",}}> <Link style={{textDecoration: "none", color: "#327dffff"}} to="/dimensi-configs"> Konfigurasi Nilai Guru</Link> </button>
          </div>
          <div className='ml-2'>
            <button  className=" btn " style={{fontSize: '15px', padding:'5px 10px', marginTop: '-2px',  borderRadius: "10px 10px 0px 0px", backgroundColor:"#076db5ff", color: "#fff"}}> Konfigurasi Nilai Kepala Sekolah </button>
          </div>

          <div className='ml-2'>
            <button  className=" btn " style={{fontSize: '15px', padding:'5px 10px', marginTop: '-2px',  borderRadius: "10px 10px 0px 0px"}}> <Link style={{textDecoration: "none", color: "#327dffff"}} to="/dimensi-config-heads-new"> Konfigurasi Nilai Kepala Sekolah New</Link> </button>
          </div>

          <div className='ml-2'>
            <button  className=" btn " style={{fontSize: '15px', padding:'5px 10px', marginTop: '-2px',  borderRadius: "10px 10px 0px 0px"}}> <Link style={{textDecoration: "none", color: "#327dffff"}} to="/config-list-dimensi"> Konfigurasi Dimensi</Link> </button>
          </div>
        </div>
        <hr style={{borderBottom: "1px solid #327dffff", marginTop: "-22px"}}/>

        {/* ========================== FILTER ========================== */}

        {isTabletOrMobile ? (
          <>
            <div className="title-page">
              <Row style={{marginTop: "10px", padding:"0 12px"}}>
                <select className="mr-2" aria-label="Default select example" name="ysb_semester_id" value={form2?.ysb_semester_id}  onChange={handleChange}
                style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                                  
                <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                  {getDataSemesterMap.map((user,index) => (
                    <option key={index} value={user?.id} style={{textAlign:""}}>{user?.name_year} (Semester {user?.semester})</option>
                  ))}  
                </select>
              </Row>
                  
              <Row style={{marginTop: "10px", padding:"0 12px"}}>
                <select className="mr-2" aria-label="Default select example" name="ysb_dimensi_id" value={form2?.ysb_dimensi_id}  onChange={handleChange}
                style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                                  
                  <option value="" hidden>Pilih Dimensi</option>
                  {getDataDimensi.map((user,index) => (
                    <option value={user?.id} style={{textAlign:""}}>{user?.name_dimensi}</option>
                    ))} 
                </select>
              </Row>
        
              <Row style={{marginTop: "10px", padding:"0 12px"}}>
                <select className="mr-2" aria-label="Default select example" name="ysb_branch_id" value={form2?.ysb_branch_id}  onChange={handleChange}
                style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                                  
                  <option value="" hidden>Pilih Cabang</option>
                  {getDataBranch.map((user,index) => (
                    <option value={user?.branch_code} style={{textAlign:""}}>{user?.branch_name}</option>
                  ))}
                </select>
              </Row>
        
              <Row style={{marginTop: "10px", padding:"0 12px"}}>
                <select
                          className="mr-2"
                          name="ysb_school_id"
                          value={form2.ysb_school_id}
                          onChange={handleChange}
                          disabled={loadingSchool}
                          style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                            cursor: loadingSchool ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                          </option>

                          {!loadingSchool &&
                            getDataSchool.map((user, index) => (
                              <option key={index} value={user?.school_code}>
                                {user?.school_name}
                              </option>
                            ))}
                      </select>
              </Row>
        
                                              
              <Row style={{marginTop: "12px", padding:"0 12px"}}>
                 <button
                        onClick={handleCari}
                        disabled={!isFilterComplete}
                        className="btn"
                        style={{
                          fontSize: "13px",
                          padding: "10px 16px",
                          borderRadius: "12px",
                          backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                          color: "#fff",
                          cursor: !isFilterComplete ? "not-allowed" : "pointer",
                        }}
                      >
                        Cari
                      </button>
              </Row>
            </div>
          </>
        ) : (
          <>
            <div className="mb-3">
              {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:250, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:190, borderRadius: "12px"}} />
                    </div>
                    
                    <div className="d-flex">
                       <div className="shimmer shimmer-select mr-2" style={{width:150, borderRadius: "12px"}} />
                       <div className="shimmer shimmer-select mr-2" style={{width:70, borderRadius: "12px"}} />
                    </div>
                  </>
              ) : (
                <div className="mb-3 mt-4">
                  <div className="d-flex">
                    {/* SEMESTER */}
                    <select className="mr-2" name="ysb_semester_id" value={form2?.ysb_semester_id} onChange={handleChange}
                     style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                  >
                        <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                        {getDataSemesterMap.map((user, index) => (
                          <option key={index} value={user?.id} style={{textAlign:""}}>{user?.name_year} (Semester {user?.semester})</option>
                        ))}  
                    </select>

                    {/* CABANG */}
                    <select className="mr-2" onChange={handleChange} value={form2?.ysb_branch_id}  name="ysb_branch_id"
                     style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                  >
                      {getDataBranch.map((branch, index) => (
                        <option value={branch?.branch_code} style={{textAlign:""}}>{branch?.branch_name}</option>
                      ))}      
                    </select>

                    {/* SEKOLAH */}
                    {/* <select className="mr-2" onChange={handleChange} value={form2?.ysb_school_id}  name="ysb_school_id" style={{ border: "1px solid #3f5bea", borderRadius: "3px", fontSize: '14px', padding:'5px 5px'}}>

                      {getDataSchool.filter((school) => school.school_code !== "BASEMENT_BEKASI")  
                        .map((school, index) => (
                          <option key={index} value={school?.school_code}>
                            {school?.school_name}
                          </option>
                        ))
                      }

                    </select> */}

                     <select
                          className="mr-2"
                          name="ysb_school_id"
                          value={form2.ysb_school_id}
                          onChange={handleChange}
                          disabled={loadingSchool}
                          style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                            cursor: loadingSchool ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                          </option>

                          {!loadingSchool &&
                            getDataSchool.map((user, index) => (
                              <option key={index} value={user?.school_code}>
                                {user?.school_name}
                              </option>
                            ))}
                      </select>
                  </div>

                  <div className="mt-3 d-flex">
                    {/* DIMENSI */}
                    <select className="mr-2" onChange={handleChange} value={form2?.ysb_dimensi_id}  name="ysb_dimensi_id" 
                    style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                    >
                      {getDataDimensi.map((dimensi,index) => (
                        <option value={dimensi?.id}>{dimensi?.name_dimensi}</option>
                      ))}      
                    </select>

                    {/* <button onClick={handleCari} className="btn " style={{fontSize: '13px', padding:'5px 10px', marginTop: '-2px', borderRadius:"3px", backgroundColor:"#eca91aff", color: "#fff"}}> Cari</button> */}

                    <button
                        onClick={handleCari}
                        disabled={!isFilterComplete}
                        className="btn"
                        style={{
                          fontSize: "13px",
                          padding: "10px 16px",
                          borderRadius: "12px",
                          backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                          color: "#fff",
                          cursor: !isFilterComplete ? "not-allowed" : "pointer",
                        }}
                      >
                        Cari
                      </button>

                  </div>
                </div>
              )} 
            </div>
            
          </>
        )}

        {/* LOADER di area table (opsional tapi bagus) */}
        {isFetching && (
          <div className="text-center" style={{ padding: "10px 0" }}>
            <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
          </div>
        )}

        {/* ========================== TABS & TABLE ========================== */}
        {/* TABLE hanya muncul jika sudah search (atau first load selesai) */}
        {hasSearched && !isFetching && (
          <Tabs
            activeKey={selectedTab}
            onSelect={(k) => setSelectedTab(k)}
            className="mt-4 nav-tabs"
          >
            {(getData?.[0]?.data_element || []).map(
              (element, idx) => (
                <Tab
                  key={idx}
                  eventKey={element.name_element}
                  title={element.name_element}
                >
                  <div
                    className="text-center"
                    style={{
                      marginTop: "15px",
                      backgroundColor: "#9fd5ffff",
                      padding: "5px",
                    }}
                  >
                    <h5>{element.description}</h5>
                  </div>

                  <Col xl="12" sm="12">
                    <div className="mt-3 body-table">
                      <div className="test-table test-check">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Sekolah</th>

                              {element.rekapan?.[0]?.sub_elements?.map(
                                (sub, i) => (
                                  <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} key={i} className="text-center">
                                    {sub.ysb_sub_element_name}
                                  </th>
                                )
                              )}
                            </tr>
                          </thead>

                          {/* <tbody>
                            {element.rekapan.map((rekap, rIdx) => (
                              <tr key={rIdx} className="text-center">
                                <td>{rekap.school_name}</td>

                                {rekap.sub_elements.map(
                                  (sub, sIdx) => {
                                    const cellId =
                                      rekap.ysb_grade_level_id +
                                      "_" +
                                      sub.ysb_sub_element_id;

                                    const currentValue =
                                      values[cellId] ??
                                      sub.form_state ??
                                      0;

                                    return (
                                      <td
                                        key={sIdx}
                                        className="text-center"
                                        style={{ lineHeight: "2", fontSize: "22px" }}
                                      >
                                         <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ height: "30px" }}
                                          >
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "42px",
                                                height: "22px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                            {savingMap[cellId] ? (
                                              <ClipLoader size={16} color="#3f5bea" />
                                            ) : (
                                              <div className="form-check form-switch m-0">
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={currentValue === 1}
                                                  onChange={(e) => {
                                                    const newState = e.target.checked ? 1 : 0;

                                                    setValues(
                                                      (prev) => ({
                                                        ...prev,
                                                        [cellId]: newState,
                                                      })
                                                    );

                                                    handleToggleSubElement(
                                                      sub,
                                                      rekap,
                                                      element,
                                                      newState,
                                                      cellId
                                                    );
                                                  }}
                                                />
                                              </div>
                                              
                                            )}
                                            
                                          </div>
                                        </div>
                                      </td>
                                    );
                                  }
                                )}
                              </tr>
                            ))}
                          </tbody> */}

                          <tbody>
                            {element.rekapan.map((rekap, rIdx) => (
                              <tr key={rIdx} className="text-center">
                                <td>{rekap.school_name}</td>

                                {rekap.sub_elements.map((sub, sIdx) => {
                                  // ✅ cellId unik per FILTER + ELEMENT + GRADE + SUB
                                  const cellId = `${filterKey}|${element.id}|${rekap.ysb_grade_level_id}|${sub.ysb_sub_element_id}`;
                                  const currentValue = sub.form_state ?? 0;

                                  const qk = queryKeyRef.current;

                                  return (
                                    <td key={sIdx} className="text-center" style={{ lineHeight: "2", fontSize: "22px" }}>
                                      <div className="d-flex justify-content-center align-items-center" style={{ height: "30px" }}>
                                        <div
                                          style={{
                                            position: "relative",
                                            width: "42px",
                                            height: "22px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          {savingMap[cellId] ? (
                                            <ClipLoader size={16} color="#3f5bea" />
                                          ) : (
                                            <div className="form-check form-switch m-0">
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={currentValue === 1}
                                                onChange={(e) => {
                                                  if (savingMap[cellId]) return; // ✅ extra guard
                                                  const newState = e.target.checked ? 1 : 0;

                                                  handleToggleSubElement(sub, rekap, element, newState, cellId, qk);
                                                }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Tab>
              )
            )}
          </Tabs>
        )}
        
      </div>
    </div>
    </>
    
  );
}
